import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, useErrorHandler} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {FundRepresentativeModel, useLockUsers} from '../../../../entities';

interface BanFundRepresentativeModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  representative: FundRepresentativeModel;
}

export const BanFundRepresentativeModal = ({open, setOpen, representative}: BanFundRepresentativeModalProps) => {
  const {lockUserMutation, unlockUserMutation} = useLockUsers({
    userId: representative.id,
    setOpen,
    invalidateKeys: [
      ['fund-representative', representative.id],
      ['fund-representatives'],
    ],
  });

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Представитель Фонда',
    title: 'Ошибка при блокировке представителя фонда',
  });

  useEffect(() => {
    if (lockUserMutation.error) {
      handleError(lockUserMutation.error as unknown as ApiError);
    }
    if (unlockUserMutation.error) {
      handleError(unlockUserMutation.error as unknown as ApiError);
    }
  }, [lockUserMutation.error, unlockUserMutation.error, handleError]);

  const handleSubmit = () => {
    if (representative.lockedAt) {
      unlockUserMutation.mutate(representative.id);
    } else {
      lockUserMutation.mutate(representative.id);
    }
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleSubmit}
        isLoading={lockUserMutation.isPending || unlockUserMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={representative.lockedAt ? 'Разблокировать' : 'Блокировка представителя фонда'}
        textButtonApply={representative.lockedAt ? 'Разблокировать' : 'Заблокировать'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          {!representative.lockedAt
            ? 'Вы уверены, что хотите заблокировать этого представителя фонда? После блокировки этот аккаунт потеряет доступ к кабинету.'
            : 'Вы уверены, что хотите разблокировать этот аккаунт? Аккаунт получит доступ к кабинету.'}
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
